import { FC } from 'react';
import { PickType } from '../../../atoms/roomDetail';
import { SystemMessageType, UserDetail } from '../../../connector/type';
import './SystemMessage.scoped.scss'

interface SystemMessageProps {
  userId: string;
  userDetail: UserDetail | undefined;
  contents: { 
    systemMessageType: SystemMessageType;
    receiverName?: string;
    quantity?: number;
    fullRound?: string;
    pick?: PickType;
  };
}

const SystemMessage: FC<SystemMessageProps> = ({ userId, userDetail, contents }) => {
  let text = '';

  if (contents.systemMessageType === SystemMessageType.CLEAN_ROOM) {
    text = `방장 ${userDetail?.nickname}님이 방을 청소하였습니다.`;
  } else if (contents.systemMessageType === SystemMessageType.JOIN_USER) {
    text = `${userDetail?.nickname}님이 채팅방에 참여하였습니다.`;
  } else if (contents.systemMessageType === SystemMessageType.GIFT_BULLET) {
    text = `${userDetail?.nickname}님이 ${contents.receiverName}님에게 총알 ${contents.quantity}개를 선물하였습니다.`;
  } else if (contents.systemMessageType === SystemMessageType.PICK) {
    const pickText = contents.pick === PickType.BLUE
      ? '파랑거북이'
      : contents.pick === PickType.RED ? '빨강거북이' : '녹색거북이'
    text = `방장 ${userDetail?.nickname}님이 ${pickText}를 선택하셨습니다.`;
  } else if (contents.systemMessageType === SystemMessageType.PICK_RESULT) {
    const pickText = contents.pick === PickType.BLUE
      ? '파랑거북이'
      : contents.pick === PickType.RED ? '빨강거북이' : '녹색거북이'
    text = `${contents.fullRound} 회차 결과는 ${pickText} 입니다.`;
  }

  return (
    <div className="chatting-system-message">
      {text}
    </div>
  );
}

export default SystemMessage;